export const LAYOUT_VERSION = 2;

/** vue3-smooth-dnd group so tab strips accept cross-container drops. */
export const MULTIPANEL_DOCK_DND_GROUP = 'multipanel-dock-layout';

export const DOCK_ZONES = ['left', 'right', 'top', 'bottom', 'center'];

export const LAYOUT_REGIONS = ['left', 'right', 'top', 'bottom', 'center'];

export const PANEL_KIND_CENTER = 'center';
export const PANEL_KIND_TOOL = 'tool';

export const TAB_PLACEMENT_TOP = 'top';
export const TAB_PLACEMENT_BOTTOM = 'bottom';

export const SPLIT_MIN_FRACTION = 0.08;
export const SPLIT_MAX_FRACTION = 0.92;

export const DEFAULT_DOCK_SIZE = 0.5;

/** Chronological inner-to-outer edge wraps (matches legacy buildLayoutFromPanels). */
export const DEFAULT_EDGE_WRAP_ORDER = ['bottom', 'left', 'right', 'top'];

export const UNPIN_COLLAPSE_DELAY_MS = 300;

/** Drop target id for layout-wide docking (legacy). */
export const ROOT_DOCK_TARGET_ID = '__mp-dock-root__';

/** Persistent center region host for empty center + sub-zones. */
export const CENTER_REGION_ID = '__mp-dock-center__';

/** Pointer movement required before dock drag activates. */
export const DOCK_DRAG_THRESHOLD_PX = 6;

export const DOCK_ZONES_LIST = ['left', 'right', 'top', 'bottom', 'center'];

export const ROOT_ZONE_BAR_RATIO = 0.2;

/** Pixels from dock body edge where root edge zones win over host sub-zones. */
export const ROOT_EDGE_PRIORITY_PX = 20;

/** Bottom edge grab band (defaults to ROOT_EDGE_PRIORITY_PX). */
export const ROOT_BOTTOM_EDGE_PRIORITY_PX = ROOT_EDGE_PRIORITY_PX;

export function normalizeDockZone(zone) {
    if (zone == null || zone === '') return 'center';
    const z = String(zone).toLowerCase();
    return DOCK_ZONES_LIST.includes(z) ? z : 'center';
}

export function normalizePanelKind(kind, defaultZone) {
    if (kind === PANEL_KIND_CENTER || kind === PANEL_KIND_TOOL) return kind;
    if (normalizeDockZone(defaultZone) === 'center') return PANEL_KIND_CENTER;
    return PANEL_KIND_TOOL;
}

export function defaultEdgeForRegion(region) {
    const r = normalizeDockZone(region);
    if (r === 'center') return 'center';
    return r;
}

export function createEmptyRegions() {
    return {
        left: null,
        right: null,
        top: null,
        bottom: null,
        center: null,
    };
}
